import { initialiseTheme } from 'src/designTokens/themes';
import { applyV1TokensToRoot } from 'src/designTokens/themes/utils';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { initialiseFeatureFlagsFromGrowthBook } from 'src/featureFlags/utils';
import { i18nInitPromise } from 'src/i18n/i18next';
import { getLoggedInUserInfo } from 'src/models/appConfig/selectors';
import { initLmsConfig } from 'src/models/auth/lmsLogin/thunk';
import { getState, store } from 'src/store';
import { validateHostAppInterfaceRequirements } from './queries';
import { isLmsWeb, isSelfServe, setCookie } from './utils';

function initializePlatform() {
  // Normal platform initialization
  if (window.parent?.hostApp) {
    // Inherit from parent window
    window.hostApp = window.parent.hostApp;
  }

  if (window.hostApp) {
    // Direct window host app
    const { platform = 'webPlatform' } = window.hostApp;

    // Check if it's a known platform type
    window.isWebPlatform = !['web', 'android', 'ios', 'selfserve'].includes(
      platform,
    );
    window.moduleProps = window.hostApp.moduleProps;
    window.isWebPlatform = false;
    // Validate platform requirements
    validateHostAppInterfaceRequirements();
  } else {
    // No host app available
    window.isWebPlatform = true;
  }

  // Handle visitor token
  if (window.hostApp?.visitorToken) {
    setCookie('visitor_token', window.hostApp.visitorToken);
  }

  // Initialize LMS config if needed
  if (isLmsWeb() || isSelfServe()) {
    store.dispatch(initLmsConfig());
  }
}

const beforeWorkspaceInit = async (beforeAppInitFunction) => {
  initialiseTheme();
  initializePlatform();

  await i18nInitPromise();
  await beforeAppInitFunction();

  const userInfo = getLoggedInUserInfo(getState());

  const attributes = {
    clientCode: userInfo?.clientCode,
    userEmail: userInfo.email,
  };

  await initialiseFeatureFlagsFromGrowthBook(attributes);
  const enableV1Tokens = getGrowthBookFeatureFlag('enable-v1-tokens');
  if (enableV1Tokens) {
    applyV1TokensToRoot();
  }
};

const afterWorkspaceInit = async (afterAppInitFunction) => {
  await afterAppInitFunction();
};

export { beforeWorkspaceInit, afterWorkspaceInit };
